import { jsxs, Fragment, jsx } from "@emotion/react/jsx-runtime";
import useTicker from "./useTicker.mjs";
import capitalizeString from "lodash/capitalize";
import { Children } from "react";
import timeAgo from "./timeAgo.mjs";
import { useTranslation } from "react-i18next";
import useThemeProps from "./useThemeProps.mjs";
import formatDate from "date-fns/format";
function fixSwedishFormat(string) {
  return string.replace(/\.$/, "");
}
function getMachineDateString(date, precision) {
  const {
    [precision]: format
  } = {
    year: "yyyy",
    month: "yyyy-MM",
    day: "yyyy-MM-dd",
    hour: "yyyy-MM-dd HH",
    minute: "yyyy-MM-dd HH:mm",
    second: "yyyy-MM-dd HH:mm:SS"
  };
  return formatDate(date, format);
}
function getHumanDateString(date, locale, format) {
  let humanDate = date.toLocaleString(locale, format);
  if (locale.startsWith("sv")) {
    humanDate = fixSwedishFormat(humanDate);
  }
  return humanDate;
}
function Ago(_ref) {
  let {
    date
  } = _ref;
  useTicker(30 * 1e3);
  return timeAgo.format(date);
}
function Time(props) {
  props = useThemeProps({
    props,
    name: "Time"
  });
  let {
    ago = false,
    capitalize,
    date,
    format,
    locale,
    children,
    precision,
    as: Component = "time",
    ...restProps
  } = props;
  date = new Date(date);
  if (isNaN(date)) {
    return null;
  }
  const {
    i18n
  } = useTranslation();
  if (locale == null) {
    locale = i18n.language;
  }
  let humanDate = getHumanDateString(date, locale, format);
  precision ?? (precision = ago || !format || format.timeStyle || format.second ? "second" : format.minute ? "minute" : format.hour ? "hour" : format.dateStyle || format.day ? "day" : format.month ? "month" : "year");
  const machineDate = getMachineDateString(date, precision);
  const ownerState = {
    ago,
    capitalize,
    date,
    format,
    locale,
    precision,
    humanDate,
    machineDate,
    getMachineDateString,
    getHumanDateString
  };
  if (typeof children === "function") {
    children = children(ownerState);
  } else if (Children.count(children) > 0) {
    throw new Error(`<Time> children should be empty or a function, but got ${children}`);
  } else {
    children = ago ? /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx(Ago, {
        date,
        capitalize
      }), format ? ` (${humanDate})` : null]
    }) : capitalize ? capitalizeString(humanDate) : humanDate;
  }
  return /* @__PURE__ */jsx(Component, {
    dateTime: machineDate,
    ...restProps,
    children
  });
}
export { Time as default };